<template>
  <div class="training-registration">
    <div class="card">
      <div class="card-header">
        <span class="card-title">培训报名</span>
      </div>
      <div class="card-body">
        <div class="flex menu-bar">
          <div class="flex gap12">
            <div style="flex-shrink: 0">培训方式</div>
            <el-select v-model="value" clearable placeholder="请选择培训方式">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                size="mini"
              >
              </el-option>
            </el-select>
          </div>
          <div class="flex gap12">
            <div style="flex-shrink: 0">合辑名称</div>
            <el-input
              v-model="input"
              clearable
              placeholder="请输入合辑名称"
            ></el-input>
          </div>
          <!-- <el-checkbox v-model="checked" fill="">显示所有课程</el-checkbox> -->
          <div class="flex">
            <el-button
              size="mini"
              icon="el-icon-search"
              type="warning"
              @click="search"
              >搜索</el-button
            >
            <el-button size="mini" icon="el-icon-search" @click="reset"
              >重置</el-button
            >
          </div>
        </div>
        <div class="table-box">
          <el-table
            :data="tableData"
            border
            :header-cell-style="{ background: '#fff6e8', color: '#515a6e' }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="50rem"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="操作"
              width="170rem"
              align="center"
            >
              <template slot-scope="scope">
                <div class="flex">
                  <el-button
                    :disabled="scope.row.cartStatus || scope.row.signUpStatus"
                    class="button"
                    @click="toAddCart(scope.row)"
                    >加入课程表</el-button
                  >
                  <el-button class="button" @click="toDetails(scope.row)"
                    >查看</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :prop="value"
              :label="item"
              v-for="(item, value) in tableTitle"
              :key="item"
              align="center"
              :width="getColumnWidth(value, item)"
            >
            </el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="10"
              layout="prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getTrainingList, addCart } from "@/api/course.js";
import { findRoute } from "@/utils/routerHelper.js";
export default {
  data() {
    return {
      checked: true,
      value: "",
      input: "",
      options: [
        {
          value: "面授",
          label: "面授",
        },
        {
          value: "网络",
          label: "网络",
        },
      ],
      tableTitle: {
        trainingBatch: "培训批次",
        category: "课程分类",
        trainingTitle: "培训标题",
        trainingType: "培训方式",
        albumName: "合辑名称",
        trainingPlaces: "培训名额",
        signUpCount: "报名人数",
        availableSlots: "剩余人数",
        beginTime: "开课时间",
        endTime: "结课时间",
        // classHours: "学时",
      },
      tableData: [],
      currentPage: 1,
      total: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapMutations("routerData", ["changeRouterList"]),
    getData(params) {
      let obj = {};
      if (params) {
        obj = params;
      }
      getTrainingList({
        current: this.currentPage,
        size: 16,
        ...obj,
      }).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records.map((v) => {
            v.beginTime = v.beginTime ? v.beginTime.slice(0, -3) : "";
            v.endTime = v.endTime ? v.endTime.slice(0, -3) : "";
            v.category =
              v.category && v.category.length > 0 ? v.category.join(",") : "";
            return v;
          });
          this.total = res.data.data.total;
        }
      });
    },
    toAddCart(data) {
      addCart({
        trainingId: data.id,
        trainingDetail: data,
      }).then((res) => {
        // console.log(res)
        if (res.data.code == 200) {
          if (res.data.data) {
            this.$message.success("加入课程表成功");
          } else {
            this.$message.error("加入课程表失败，稍后再试");
          }
        }
        // else{
        //   this.$message.error(res.data.msg)
        // }
      });
    },
    toDetails(data) {
      this.$router.push({
        path: "/associationNews/courseDetails",
        query: { id: data.id },
      });
      let routerList = [];
      let routers = [
        "/personalCenter",
        "trainingSystemRegistration",
        "/associationNews/courseDetails",
      ];
      for (let i = 0; i < routers.length; i++) {
        let routerData = findRoute(this.$router.options.routes, routers[i]);
        routerList.push(routerData);
      }
      this.changeRouterList(routerList);
    },
    search() {
      this.currentPage = 1;
      this.getData({
        trainingType: this.value,
        trainingName: this.input,
      });
    },
    reset() {
      this.value = "";
      this.input = "";
    },
    handleSizeChange(index) {},
    handleCurrentChange(index) {
      this.currentPage = index;
      this.getData();
    },
    getColumnWidth(prop, label) {
      // 根据 prop 或 label 指定特定列的宽度
      if (
        prop === "trainingPlaces" ||
        prop === "signUpCount" ||
        prop === "availableSlots"
      ) {
        return "70px";
      }
      if (prop === "trainingType") {
        return "50px";
      }
      return "";
    },
  },
};
</script>

<style lang="less" scoped>
.training-registration {
  height: 100%;
  .card {
    background: #fff;
    border-radius: 24px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    height: 100%;

    .card-header {
      margin-bottom: 20px;

      .card-title {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
      }
    }
  }
}
.menu-bar {
  font-size: 14px;
  color: #606266;
  gap: 21px;
}
.gap12 {
  gap: 12px;
}
::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ed9d26;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ed9d26;
  border-color: #ed9d26;
}
.table-header {
  background: #fff6e8;
  border: 1px solid #f5f0eb;
}
.table-box {
  margin-top: 20px;
  width: 1208px;
  overflow: hidden;
}
.button {
  height: 24px;
  line-height: 24px;
  background: #ed9d26;
  border-radius: 4px;
  padding: 0 8px;
  border: none;
  margin-right: 8px;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}

.pages {
  margin-top: 34px;
  display: flex;
  justify-content: flex-end;
}
::v-deep .el-pager li.active {
  color: #ed9d26;
}
</style>
